import { Navigate, useLocation } from 'react-router-dom';
import { useUserStore } from 'src/hooks/stores';
import {
    buildLoginRedirectPath,
    getRoutePathWithSearch,
} from 'src/utils/authRedirect';

interface RequireAuthProps {
    children: React.ReactNode;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
    const { accessToken } = useUserStore();
    const location = useLocation();

    const isAuthenticated = !!accessToken;

    if (!isAuthenticated) {
        const currentPath = getRoutePathWithSearch(location);
        return (
            <Navigate
                to={buildLoginRedirectPath(currentPath)}
                replace
            />
        );
    }

    return <>{children}</>;
};

export default RequireAuth;
